import { AfterViewInit, Component, inject } from '@angular/core';
import { GoogleMap, MapAdvancedMarker } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { NewCustomerAddress } from '../../../interfaces/new-customer.model';
import { addressLocation } from '../../../utils/new-customer.utils';

// Sede proposta come destino sulla mappa dell'app: la X torna alle sedi
@Component({
  selector: 'ord-new-customer-map-dialog',
  imports: [GoogleMap, MapAdvancedMarker, MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title class="dialog-header">
      <span class="dialog-title">
        <span class="title-medium-emphasized">Destino di consegna</span>
        <span class="body-small">{{ data.indirizzo }}</span>
      </span>
      <button matIconButton type="button" aria-label="Chiudi" class="close-button" mat-dialog-close>
        <i class="fa-regular fa-xmark" aria-hidden="true"></i>
      </button>
    </h2>
    <mat-dialog-content class="map-content">
      <!-- I marker avanzati vogliono l'ID della mappa -->
      <google-map mapId="mapProva" height="100%" width="100%" [center]="position" [zoom]="16" [options]="mapOptions">
        <map-advanced-marker [position]="position" [title]="title" />
      </google-map>
    </mat-dialog-content>
  `,
  styles: `
    .dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--mat-sys-spacing-16);
      color: var(--mat-sys-primary);
    }

    .dialog-title {
      display: grid;
      flex: 1;
      min-width: 0;
    }

    .close-button {
      flex: 0 0 auto;
    }

    .map-content {
      height: min(560px, 70vh);
      width: min(720px, 85vw);
      max-height: none;
      padding: 0;
    }
  `,
})
export class NewCustomerMapDialog implements AfterViewInit {
  readonly data = inject<NewCustomerAddress>(MAT_DIALOG_DATA);
  readonly position: google.maps.LatLngLiteral = { lat: this.data.latitudine ?? 0, lng: this.data.longitudine ?? 0 };
  readonly title = [this.data.tipoSede, addressLocation(this.data.cap, this.data.comune, this.data.provincia)].filter(Boolean).join(' · ');
  readonly mapOptions: google.maps.MapOptions = {
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
    rotateControl: false,
    clickableIcons: false,
  };

  ngAfterViewInit(): void {
    google.maps.importLibrary('marker');
  }
}
